export default __webpack_public_path__ + "static/media/warriors-new-crop.51ab232b.jpg";